<script setup lang="ts">
	import { computed } from 'vue';
	import SymIcon from "@fd/helpers/SymIcon.vue";
	
	const props = defineProps({
		id: String,
		isTitleHtml: Boolean,
		title: String,
		isSortable: Boolean,
		isFilterable: Boolean,
		filterableList: Array,
		component: String,
		sortColumn: String,
		sortOrderAsc: Boolean,
		sortColumnClass: String,
		modelValue: String
	});
	
	const emit = defineEmits(['sortBy', 'refresh','update:modelValue']);
	
	const niceTitle = computed(() => {
		if (props.isFilterable || props.filterableList) {
			return props.title+(props.isTitleHtml?"&nbsp":" ");
		}
		return props.title;
	});
	
	function inputStyle(property): string {
		if (Boolean(property)) {
			let width: number = property.length*10+20;
			if (width<50) width=50;
			if (width>120) width=120;
			return "width: "+width+"px;";
		}
		return "";
	}
	
	function sort(): void {
		if (props.isSortable) {
			if (props.id===props.sortColumn) {
				emit("sortBy", props.sortColumn);
			}
			else {
				emit("sortBy", props.id);
			}
		}
	}
	
	function headerClass(): string {
		if (props.id===props.sortColumn) return props.sortColumnClass;
		return "";
	}
		
	function isSortedColumn(): boolean {
		return props.id===props.sortColumn;
	}
	
	function resetValue(event): void {
		emit('update:modelValue', '');
		emit('refresh');
		event.target.blur();
	}
	
</script>
<template>
	<th :class="{activeclick: isSortable, nw: true}">
		<span v-if="isTitleHtml" v-html="niceTitle" @click="sort"></span>
		<span v-else :class="headerClass()" @click="sort">{{niceTitle}}</span>
		<sym-icon v-if="isSortedColumn()" style="padding-left: 2px;" :name="sortOrderAsc?'caret-up-14-bold':'caret-down-14-bold'" @click="sort"/>
		<select v-if="filterableList" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)"
				class="thqbe-select" :style="inputStyle(modelValue)" @change="$emit('refresh')" @keyup.esc="resetValue">
				<option v-for="option in filterableList" :value="option.id">{{option.text}}</option>
		</select>
		<input v-else-if="isFilterable" class="thqbe" enterkeyhint="search" :style="inputStyle(modelValue)" placeholder=""
			   :value="modelValue" @input="$emit('update:modelValue', $event.target.value)"
				type="text" size="2" @focusout="$emit('refresh')" @keyup.enter="$emit('refresh')" @keyup.esc="resetValue">
	</th>
</template>

